module.exports = __webpack_public_path__ + "static/img/kubrickheader.00fe374f.jpg";